// source: api/soter-task/common/v1/video_platform_enum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.videoTaskPlatform.TaskVideoPlatform', null, global);
/**
 * @enum {number}
 */
proto.videoTaskPlatform.TaskVideoPlatform = {
  NONE: 0,
  IOS: 1,
  ANDROID: 2,
  DASHBOARD_UPLOAD: 3,
  IOS_UPLOAD: 4,
  ANDROID_UPLOAD: 5,
  IOS_FRONT: 6,
  ANDROID_FRONT: 7
};

goog.object.extend(exports, proto.videoTaskPlatform);
